import { api } from "../../api";
import {handleResponse, RequestOptions} from "../types";
import {getCookie} from "../../helpers/utils";
import {cookieToken} from "../../constants";

const getList = (data:any) => {
  const authenticity_token = getCookie(cookieToken);
  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };
  return fetch(`${api.admin.reattributedPlayers.list}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}


const create = (data: any) => {
  const endpoint = api.admin.reattributedPlayers.create;

  const payload = {
    ...data.data,
  };

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const reattributedPlayersService = {
  getList,
  create,
};
